@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.betType {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--cxy-color-surface-primary-default-subtle);
  cursor: pointer;
  padding: var(--cxy-spacing-xxxsm);

  &.diamond {
    border: 2px solid #00dddd;
  }

  &.hot {
    border: 2px solid #ff435a;
  }

  &.small {
    height: 18px;
    width: 18px;
    min-width: 18px;
    border-width: 1px;
    padding: var(--cxy-spacing-0);
  }

  &.medium {
    height: 40px;
    width: 40px;
    min-width: 40px;
  }
}

.content {
  @include cxy.font-size('text-xxs');
  background-color: var(--cxy-color-surface-page);
  color: var(--cxy-color-text-default-placeholder);
  margin: calc(var(--cxy-spacing-3) * -1);
  padding: var(--cxy-spacing-xxsm);
  border-radius: var(--cxy-border-radius-m);
  border: none;
  box-shadow: var(--cxy-box-shadow-b);
  user-select: none;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  max-width: 205px;
  z-index: var(--cxy-z-index-tooltip);

  &[data-state='delayed-open'][data-side='top'] {
    animation-name: slideDownAndFade;
  }
  &[data-state='delayed-open'][data-side='right'] {
    animation-name: slideLeftAndFade;
  }
  &[data-state='delayed-open'][data-side='bottom'] {
    animation-name: slideUpAndFade;
  }
  &[data-state='delayed-open'][data-side='left'] {
    animation-name: slideRightAndFade;
  }

  .arrow {
    fill: var(--cxy-color-surface-page);
    height: 10px;
    width: 10px;
  }
}

[data-fpsm-theme='gazzetta'] {
  .betType {
    background-color: var(--cxy-color-surface-secondary-default-subtle);
  }
}
